import React, {useEffect, useRef, useState} from 'react';
import ArtistSuggestionsItemEditorFooter from "./ArtistSuggestionsItemEditorFooter";
import cl from "../BaseSimplePage/BaseSimpleItemEditor.module.css";
import {Alert, LinearProgress} from "@mui/material";
import ArtistSuggestionsItemEditorHeader from "./ArtistSuggestionsItemEditorHeader";
import ServerManager from "../../API/ServerManager";
import ArtistSuggestionsItemFormStep1 from "./ArtistSuggestionsItemFormStep1";
import ArtistSuggestionsItemFormStep2 from "./ArtistSuggestionsItemFormStep2";
import ArtistSuggestionsItemFormStep3 from "./ArtistSuggestionsItemFormStep3";

const ArtistSuggestionsItemEditor = ({
                                           onDeleteSuggestion,
                                           onAcceptSuggestion,
                                           onLinkSuggestion,
                                           editItemId,
                                           searchByIdMode,
                                           setSnackbarData
                                       }) => {

    const [isLoading, setIsLoading] = React.useState(true);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [formData, setFormData] = useState(null);
    const formControlRef = useRef(null);

    const [step, setStep] = useState(1); // 1,2,3

    // получение данных с сервера (если режим редактирования) (один раз)
    useEffect(() => {
        async function fetch() {
            setIsLoading(true);
            setFormData(null);
            try {
                const itemData = await ServerManager.getSimpleModeItem("artist_suggestion", editItemId);
                if (!ignore) {
                    setFormData(itemData);
                }
            } catch (error) {
                if (!ignore) {
                    if (searchByIdMode)
                        setErrorMessage(`Запись с ID=${editItemId} не найдена`);
                    else
                        setErrorMessage(`Ошибка при загрузке данных: ${error}`);
                }
            } finally {
                if (!ignore) setIsLoading(false);
            }
        }

        let ignore = false;
        fetch();
        return () => {
            ignore = true;
        }
    }, []);

    function handleAcceptSuggestionBtnClick() {
        const data = tryValidateAndGetFormData();
        if (data)
            onAcceptSuggestion(editItemId, data);
    }

    function handleLinkSuggestionBtnClick() {
        const linkedArtistId = formControlRef.current.getLinkedArtistId();

        if (linkedArtistId === 0) {
            setSnackbarData({severity: "error", title: "Нужно найти и выбрать вариант автора для связи!"});
            return;
        }

        onLinkSuggestion(editItemId, linkedArtistId);
    }

    function tryValidateAndGetFormData() {
        if (!formControlRef.current.validate()) {
            setSnackbarData({
                severity: "error",
                title: "Ошибка в заполнении!",
                message: "Необходимо исправить отмеченные поля"
            });
            return false;
        }

        return formControlRef.current.getData();
    }

    return (
        <div className={cl.main}>
            <ArtistSuggestionsItemEditorHeader
                editItemId={editItemId}
                step={step}
            />
            <div className={cl.scrollContent} key={step}>
                {isLoading && <LinearProgress/>}
                {!isLoading && errorMessage && <Alert variant="outlined" severity="error">{errorMessage}</Alert>}
                {!isLoading && !errorMessage && renderForm(step, formData, formControlRef)}
            </div>
            {!isLoading && !errorMessage && <ArtistSuggestionsItemEditorFooter
                step={step}
                onDeleteSuggestionBtnClick={() => onDeleteSuggestion(editItemId)}
                onAcceptSuggestionBtnClick={handleAcceptSuggestionBtnClick}
                onLinkSuggestionBtnClick={handleLinkSuggestionBtnClick}
                onNextBtnClick={() => setStep(step + 1)}
                onPrevBtnClick={() => setStep(step - 1)}
            />}
        </div>
    );
};

function renderForm(step, initData, controlRef) {
    if (step === 1) {
        return <ArtistSuggestionsItemFormStep1
            key={step}
            initData={initData}
            controlRef={controlRef}
        />
    }
    if (step === 2) {
        return <ArtistSuggestionsItemFormStep2
            key={step}
            initData={initData}
            controlRef={controlRef}
        />
    }
    if (step === 3) {
        return <ArtistSuggestionsItemFormStep3
            key={step}
            initData={initData}
            controlRef={controlRef}
        />
    }
    return null;
}

export default ArtistSuggestionsItemEditor;